import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyAlertBar() {
  const [isVisible, setIsVisible] = useState(true);
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-144">
      {isVisible && <motion.div initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} className="fixed top-0 left-0 right-0 z-50 bg-[#A0525A] text-white py-3 px-4" data-id="element-145">
          <div className="max-w-7xl mx-auto flex items-center justify-center relative" data-id="element-146">
            <p className="text-sm md:text-base font-medium text-center pr-8" data-id="element-147">
              <motion.span animate={{
            scale: [1, 1.2, 1]
          }} transition={{
            repeat: Infinity,
            duration: 2
          }} className="inline-block" data-id="element-148">
                🔥
              </motion.span>{' '}
              SOLO POR HOY: Acceso completo + 10 Bonos de Regalo — ¡Oferta por
              tiempo limitado!
            </p>
            <button onClick={() => setIsVisible(false)} className="absolute right-0 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors" aria-label="Cerrar" data-id="element-149">
              <XIcon className="w-5 h-5" data-id="element-150" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}